export var card = {
  yangi: [
    {
      id: 1,
      categoria: 'yangi',
      orderId: 1234,
      time: new Date(),
      total: '40000',
      user: {
        name: 'Guli Said',
        phone: 12345678,
      },
      operator: {
        name: 'Maria Masha',
      },
      filial: {
        title: 'Fast Food',
        location: 'Ansan Station',
      },
    },
    {
      id: 2,
      orderId: 56789,
      categoria: 'yangi',

      time: new Date(),
      total: '40000',
      user: {
        name: 'Guli Khan',
        phone: 8765432,
      },
      operator: {
        name: 'Azamat Bek',
      },
      filial: {
        title: 'Burger',
        location: 'Ansan Station',
      },
    },
    {
      id: 3,
      categoria: 'yangi',

      orderId: 56789,
      time: new Date(),
      total: '40000',
      user: {
        name: 'Guli Khan',
        phone: 8765432,
      },
      operator: {
        name: 'Azamat Bek',
      },
      filial: {
        title: 'Burger',
        location: 'Ansan Station',
      },
    },
  ],
  qabul: [
    {
      id: 21,
        categoria: 'qabul',
  
        orderId: 1234,
        time: new Date(),
        total: '40000',
        user: {
          name: 'Guli Said',
          phone: 12345678,
        },
        operator: {
          name: 'Maria Masha',
        },
        filial: {
          title: 'Fast Food',
          location: 'Ansan Station',
        },
      },
      {
        id: 22,
        categoria: 'qabul',
  
        orderId: 56789,
        time: new Date(),
        total: '40000',
        user: {
          name: 'Guli Khan',
          phone: 8765432,
        },
        operator: {
          name: 'Azamat Bek',
        },
        filial: {
          title: 'Burger',
          location: 'Ansan Station',
        },
    },
  ],
  jonatilganlar: [
    {
      id: 31,
      categoria: 'jonatilgan',

      orderId: 1234,
      time: new Date(),
      total: '40000',
      user: {
        name: 'Guli Said',
        phone: 12345678,
      },
      operator: {
        name: 'Maria Masha',
      },
      filial: {
        title: 'Fast Food',
        location: 'Ansan Station',
      },
    },
  ],
  yopilgan: [
    {
      id: 41,
      categoria: 'yopilgan',

      orderId: 1234,
      time: new Date(),
      total: '40000',
      user: {
        name: 'Guli Said',
        phone: 12345678,
      },
      operator: {
        name: 'Maria Masha',
      },
      filial: {
        title: 'Fast Food',
        location: 'Ansan Station',
      },
    },
    {
      id: 42,
      categoria: 'yopilgan',

      orderId: 56789,
      time: new Date(),
      total: '40000',
      user: {
        name: 'Guli Khan',
        phone: 8765432,
      },
      operator: {
        name: 'Azamat Bek',
      },
      filial: {
        title: 'Burger',
        location: 'Ansan Station',
      },
    },
  ],
};
